/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type InvitePolicyEnum = "AdminOnly" | "AnyMember" | "%future added value";
export type PatchBillingGroupMutationInput = {
    billingGroupId: string;
    clientMutationId?: string | null | undefined;
    invitePolicy: InvitePolicyEnum;
    name?: string | null | undefined;
    orgRelayId: string;
};
export type PatchBillingGroupMutationVariables = {
    input: PatchBillingGroupMutationInput;
};
export type PatchBillingGroupMutationResponse = {
    readonly patchBillingGroup: {
        readonly clientMutationId: string | null;
    } | null;
};
export type PatchBillingGroupMutation = {
    readonly response: PatchBillingGroupMutationResponse;
    readonly variables: PatchBillingGroupMutationVariables;
};



/*
mutation PatchBillingGroupMutation(
  $input: PatchBillingGroupMutationInput!
) {
  patchBillingGroup(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "PatchBillingGroupMutationPayload",
            "kind": "LinkedField",
            "name": "patchBillingGroup",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "PatchBillingGroupMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "PatchBillingGroupMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "f46b4f8e6100999e731457e5b33d84aa",
            "id": null,
            "metadata": {},
            "name": "PatchBillingGroupMutation",
            "operationKind": "mutation",
            "text": "mutation PatchBillingGroupMutation(\n  $input: PatchBillingGroupMutationInput!\n) {\n  patchBillingGroup(input: $input) {\n    clientMutationId\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'b3467da01d204ca9fed27681c96d49b5';
export default node;
